const accessUsers = {

    PROFILE: { name: 'Profile', path: '/profile' },
    UPDATE_PROFILE: { name: 'Update Profile', path: '/update-profile' },

    STAFF_LIST: { name: 'Staff', path: '/staff-list' },
    ADD_STAFF: { name: 'Add Staff', path: '/create-staff' },
    UPDATE_STAFF: { name: 'Update Staff', path: '/edit-staff' },
    DELETE_STAFF: { name: 'Delete Staff', path: '/delete-staff' },
    STAFF_DETAILS: { name: 'Staff Details', path: '/staff-details' },

    ASSIGN_DEPARTMENT_LIST: { name: 'Assign Department', path: '/assign-department-list' },
    ADD_ASSIGN_DEPARTMENT: { name: 'Add Assign Department', path: '/create-assign-department' },
    UPDATE_ASSIGN_DEPARTMENT: { name: 'Update Assign Department', path: '/edit-assign-department' },
    DELETE_ASSIGN_DEPARTMENT: { name: 'Delete Assign Department', path: '/delete-assign-department' },

}

export default accessUsers;